var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShown),expression:"isShown"}],staticClass:"button hidden xl:flex",on:{"click":_vm.scrollToTop}},[_c('ChevronUpIcon',{staticClass:"h-6"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }